<div class="cell auto" *ngIf="parameters">
    <kiwi-parameters-tab-content-header
        [saveDisabled]="arePeriodParametersReadonly()"
        (saved)="updateParameters()"
        [titleLabelKey]="'parameters.dining.rooms.title'">
    </kiwi-parameters-tab-content-header>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <p [i18nKey]="'parameters.dining.rooms.description'"></p>

    <kiwi-spacer [size]="24"></kiwi-spacer>

    <h3 [i18nKey]="'parameters.dining.rooms.seating.capacity.title'"></h3>

    <p [i18nKey]="'parameters.dining.rooms.seating.capacity.description'"></p>

    <table class="_tableColor">
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.dining.rooms.seating.capacity'"></td>
            <td>
                <input type="number"
                       [(ngModel)]="parameters.diningRoomsParameters.diningRoomSeatingCapacity"
                       [disabled]="areSessionParametersReadonly()">
            </td>
        </tr>
        </tbody>
    </table>

    <p [i18nKey]="'parameters.dining.rooms.standard.maintenance.budget.description'"></p>

    <table class="_tableColor">
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.dining.rooms.standard.maintenance.budget'"></td>
            <td>
                <kiwi-currency-input [(ngModel)]="parameters.maintenanceParameters.standardMaintenanceBudgetPerRoom"
                                     [disabled]="areSessionParametersReadonly()"></kiwi-currency-input>
            </td>
        </tr>
        </tbody>
    </table>

    <h3 [i18nKey]="'parameters.dining.rooms.rent.title'"></h3>

    <p [i18nKey]="'parameters.dining.rooms.rent.description'"></p>

    <table class="_tableColor">
        <thead>
        <tr class="_titlePartTable">
            <th></th>
            <th style="text-align:center"[i18nKey]="'common.area.working.class'"></th>
            <th style="text-align:center"[i18nKey]="'common.area.average'"></th>
            <th style="text-align:center"[i18nKey]="'common.area.wealthy'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.dining.rooms.rent'"></td>
            <td>
                <kiwi-currency-input [(ngModel)]="parameters.rentParameters.workingClassAreaDiningRoomRent"
                                     [disabled]="arePeriodParametersReadonly()"></kiwi-currency-input>
            </td>
            <td>
                <kiwi-currency-input [(ngModel)]="parameters.rentParameters.averageAreaDiningRoomRent"
                                     [disabled]="arePeriodParametersReadonly()"></kiwi-currency-input>
            </td>
            <td>
                <kiwi-currency-input [(ngModel)]="parameters.rentParameters.wealthyAreaDiningRoomRent"
                                     [disabled]="arePeriodParametersReadonly()"></kiwi-currency-input>
            </td>
        </tr>
        </tbody>
    </table>

    <h3 [i18nKey]="'parameters.dining.rooms.purchase.title'"></h3>

    <p [i18nKey]="'parameters.dining.rooms.purchase.description'"></p>

    <table class="_tableColor">
        <thead>
        <tr class="_titlePartTable">
            <th></th>
            <th style="text-align:center"[i18nKey]="'parameters.dining.rooms.standard.purchase.price'"></th>
            <th style="text-align:center"[i18nKey]="'parameters.dining.rooms.depreciation.duration'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.dining.rooms.furniture'"></td>
            <td>
                <kiwi-currency-input [(ngModel)]="parameters.diningRoomsParameters.standardFurniturePrice"
                                     [disabled]="areSessionParametersReadonly()"></kiwi-currency-input>
            </td>
            <td>
                <input type="number"
                       [(ngModel)]="parameters.diningRoomsParameters.furnitureValueDepreciationPeriodLength"
                       [disabled]="areSessionParametersReadonly()">
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'parameters.dining.rooms.layout'"></td>
            <td>
                <kiwi-currency-input [(ngModel)]="parameters.diningRoomsParameters.standardSilverwarePrice"
                                     [disabled]="areSessionParametersReadonly()"></kiwi-currency-input>
            </td>
            <td>
                <input type="number"
                       [(ngModel)]="parameters.diningRoomsParameters.silverwareValueDepreciationPeriodLength"
                       [disabled]="areSessionParametersReadonly()">
            </td>
        </tr>
        </tbody>
    </table>
</div>
